import { Parser } from "json2csv";
import sanitize from "sanitize-filename";

export const makeCanteenReportCSV = (data, meals) => {
    const parser = new Parser({ fields: [
        { value: "userID", label: "Nr użytkownika" },
        { value: "lname", label: "Nazwisko" },
        { value: "fname", label: "Imię" },
        ...meals,
        { value: "totalPrice", label: "Łączny koszt" },
        { value: "foundedPrice", label: "Łączny koszt (po dofinansowaniu)" },
    ], withBOM: true });
    const csv = parser.parse(data);

    return new Blob([csv], { type: "text/csv" });;
};

export const downloadFile = (data, name) => {
    const filename = sanitize(`${name}.csv`, { replacement: "_" });
    const url = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};